import { showToast, ToastType } from "../utils/toast.utils";
import AdForm from "../forms/Ad.form";
import { useCreateAdMutation } from "../store";
import { createAdSchema } from "../configs";

const CreateAd: React.FC = () => {
  const [createAd, { isLoading }] = useCreateAdMutation();

  const initialValues = {
    cities: [] as string[],
    image: undefined as File | undefined,
  };

  return (
    <div className="p-4 w-full">
      <AdForm
        initialValues={initialValues}
        validationSchema={createAdSchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          const result = await createAd(values);

          if (!("error" in result)) {
            showToast("bannière créée avec succès", ToastType.SUCCESS);
            resetForm();
          }
        }}
      />
    </div>
  );
};

export default CreateAd;
